module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"legend-item\" data-id=\"")
    ; __append(escapeFn( legend.id ))
    ; __append("\">\n    <div class=\"title\">")
    ; __append(escapeFn( legend.title))
    ; __append("</div>\n    ")
    ;  _.each(legend.items, function(item, key) { 
    ; __append("\n        <div><span style=\"background-color: ")
    ; __append(escapeFn( item.color ))
    ; __append(";\n                display: inline-block;\n                width: 20px;\n                height: 13px;\n                margin-right: 0.3em;\n                border: 1px solid #222222;\"></span>")
    ; __append(escapeFn( item.title ))
    ; __append("</div>\n    ")
    ;  }) 
    ; __append("\n</div>")
  }
  return __output.join("");

}